import React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'
import { useMediaQuery } from '@mui/material'

interface BootstrapDialogProps extends DialogProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge'
  minHeight?: string
}

const BootstrapDialog = styled(Dialog)<BootstrapDialogProps>(({ theme, size, minHeight }) => ({
  '& .MuiDialog-paper': {
    maxWidth:
      size === 'small'
        ? '400px'
        : size === 'medium'
          ? '600px'
          : size === 'large'
            ? '900px'
            : size === 'xlarge'
              ? '1000px'
              : '600px',
    width: '90%',
    minHeight: minHeight || '400px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth:
        size === 'small' ? '400px' : size === 'medium' ? '600px' : size === 'large' ? '900px' : '1000px',
    },
  },
}))

interface CustomModalProps {
  open: boolean
  onClose: () => void
  title?: React.ReactNode
  bodyContent?: React.ReactNode
  footerContent?: React.ReactNode
  hasCloseBtn?: boolean
  size?: 'small' | 'medium' | 'large' | 'xlarge'
  minHeight?: string
  customHeaderStyle?: React.CSSProperties
}

const CustomModal: React.FC<CustomModalProps> = ({
  open,
  onClose,
  title = 'Default Title',
  bodyContent,
  footerContent,
  hasCloseBtn = true,
  size = 'medium',
  minHeight,
  customHeaderStyle = {},
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <BootstrapDialog
      fullScreen={fullScreen}
      onClose={onClose}
      aria-labelledby='customized-dialog-title'
      open={open}
      size={size}
      PaperProps={{ style: { minHeight: minHeight || '400px' } }}
    >
      <ModalHeader title={title} onClose={onClose} hasCloseBtn={hasCloseBtn} {...customHeaderStyle} />
      <ModalBody content={bodyContent} />
      {footerContent && <ModalFooter footerContent={footerContent} />}
    </BootstrapDialog>
  )
}

export default CustomModal
